import { useEffect, useState } from "react";
import styles from "./landing-page-user.module.css";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { CTAButton } from "BEDROCK/shared-components/cta-button";
import { usePaths } from "BEDROCK/paths";
import { LandingPageOne } from "landing-pages/landing-page-one";
import { useCollectionStore } from "entity-store/collections-store/use-collection-store";
import { TemplateCollection } from "PosterEditor/model/template-collection";

interface LandingPageUserProps {}

export const LandingPageUser = (props: LandingPageUserProps) => {
  const { role } = useAuthContext();
  const [collection, setCollection] = useState<
    TemplateCollection | undefined
  >();

  const { loadCollectionByID } = useCollectionStore();

  useEffect(() => {
    loadCollectionByID("e65925bb-bc94-47ec-b632-2f3409de4e8e").then(
      setCollection
    );
  }, []);

  if (collection === undefined) {
    return <div>Loading...</div>;
  }
  //return <div>Loaded collection</div>;
  return <LandingPageOne titleCollection={collection} />;
};
